import { toast } from "sonner";

// Fase 7A — helper condivisi per i richiami (callback) receptionist.

export const CB_STATUS_LABEL = {
  scheduled: "Programmato",
  completed: "Completato",
  cancelled: "Annullato",
};

export const CB_OUTCOME_LABEL = {
  booked: "Prenotato",
  callback_again: "Da richiamare",
  no_answer: "Nessuna risposta",
  not_interested: "Non interessato",
  other: "Altro",
};

// Soglia (minuti) oltre la quale un richiamo programmato è considerato SCADUTO.
export const OVERDUE_GRACE_MIN = 5;

export function isOverdue(cb, now = new Date()) {
  if (!cb || cb.status !== "scheduled" || !cb.scheduled_at) return false;
  return new Date(cb.scheduled_at).getTime() + OVERDUE_GRACE_MIN * 60000 < now.getTime();
}

export function isDueNow(cb, now = new Date()) {
  if (!cb || cb.status !== "scheduled" || !cb.scheduled_at) return false;
  const t = new Date(cb.scheduled_at).getTime();
  return t <= now.getTime() && t + OVERDUE_GRACE_MIN * 60000 >= now.getTime();
}

export function isToday(iso, now = new Date()) {
  if (!iso) return false;
  const d = new Date(iso);
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
}

export function fmtTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}

export function fmtDay(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "short" }); }
  catch { return iso; }
}

export const CB_KIND_LABEL = { first_call: "Prima chiamata", recall: "Richiamo" };

// Colore = TIPO (prima chiamata azzurro / richiamo viola) sovrascritto dallo STATO
// (completato verde / scaduto rosso / annullato grigio barrato).
export function callbackTone(cb, now = new Date()) {
  if (cb.status === "completed") return { label: "Completato", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" };
  if (cb.status === "cancelled") return { label: "Annullato", cls: "bg-slate-100 text-slate-400 border-slate-200 line-through" };
  if (isOverdue(cb, now)) return { label: "Scaduto", cls: "bg-rose-100 text-rose-700 border-rose-200" };
  if (cb.kind === "recall") return { label: "Richiamo", cls: "bg-violet-100 text-violet-700 border-violet-200" };
  return { label: "Prima chiamata", cls: "bg-cyan-100 text-cyan-700 border-cyan-200" };
}

export const CB_LEGEND = [
  { label: "Prima chiamata", cls: "bg-cyan-100 text-cyan-700 border-cyan-200" },
  { label: "Richiamo", cls: "bg-violet-100 text-violet-700 border-violet-200" },
  { label: "Completato", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { label: "Scaduto", cls: "bg-rose-100 text-rose-700 border-rose-200" },
  { label: "Annullato", cls: "bg-slate-100 text-slate-400 border-slate-200" },
];

// Notifica esito sync Google dopo creazione/riprogrammazione di un richiamo.
export function notifyCallbackGoogleSync(status, { rescheduled = false } = {}) {
  const base = rescheduled ? "Richiamo riprogrammato" : "Richiamo programmato";
  if (status === "synced") {
    toast.success(`${base} e ${rescheduled ? "aggiornato" : "aggiunto"} sul tuo Google Calendar`);
  } else if (status === "not_connected") {
    toast.warning(`${base}. Google Calendar non collegato: l'evento non è stato ${rescheduled ? "aggiornato" : "aggiunto"}. Collega Google dalle impostazioni.`);
  } else if (status === "failed" || status === "delete_failed") {
    toast.warning(`${base}, ma la sincronizzazione con Google Calendar non è riuscita.`);
  } else {
    toast.success(base);
  }
}

export function cbApiErr(e, fallback = "Errore") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (typeof d === "object" && d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" · ") || fallback;
  return fallback;
}
